/* eslint-disable */
// src/services/formulaService.js

import axios from "services/axiosConfig";
import { dedupeFormulasByTypeValue } from "utils/formula";

const API_URL = "/api/formula";

class FormulaService {
  // Crear fórmula
  static async createFormula(formula) {
    try {
      const response = await axios.post(API_URL, {
        Type: formula?.Type ?? formula?.type,
        Value: formula?.Value ?? formula?.value,
      });
      if (Array.isArray(response.data)) {
        return dedupeFormulasByTypeValue(response.data)[0] ?? null;
      }
      return response.data && typeof response.data === "object"
        ? response.data
        : null;
    } catch (error) {
      console.error("Error al crear la fórmula:", error);
      return null;
    }
  }
  
  // Obtener todas las fórmulas
  static async getFormulas() {
    try {
      const response = await axios.get(API_URL);
      return dedupeFormulasByTypeValue(response.data);
    } catch (error) {
      console.error("Error al obtener las fórmulas:", error);
      return [];
    }
  }

  // Obtener una formula por ID
  static async getFormulaById(id) {
    try {
      const endpoint = `${API_URL}/${id}`;
      const response = await axios.get(endpoint); 
      return response.data;
    } catch (error) {
      console.error("Error al obtener la fórmula por ID:", error);
      return null;
    }
  }

}

export default FormulaService;
